import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function isDemoExpired(dateInput: string | Date): boolean {
    if (!dateInput) return false;
    const matchDate = new Date(dateInput);
    const msDiff = Date.now() - matchDate.getTime();
    return msDiff > 28 * 24 * 60 * 60 * 1000;
}
